import type { PageData } from '../../../../_metronic/helpers/utils/types';
import * as navbarData from './navbar';
import * as footerData from './footer';
import * as homeData from './home';
import * as blogData from './blog';
import * as blogDetailData from './blogDetail';
import * as programsData from './programs';
import * as aboutData from './about';
import * as templateData from './template';
import * as resourceData from './resource';
import * as faqData from './faq';
import * as careerData from './career';
import * as contactData from './contact';
import * as businessData from './business';
import * as privacyData from './privacy';

const pageData: Record<string, Record<string, PageData>> = {
  navbarData,
  footerData,
  homeData,
  aboutData,
  templateData,
  programsData,
  resourceData,
  blogData,
  blogDetailData,
  faqData,
  careerData,
  contactData,
  businessData,
  privacyData,

};

export default pageData;
